function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ppl_svg__cls-1{fill:#28ade3}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "ppl_svg___9",
  "data-name": 9
}, /*#__PURE__*/React.createElement("path", {
  className: "ppl_svg__cls-1",
  d: "M93.29 126a1.54 1.54 0 01-1.5-1.5v-21.6c0-14.4 6.9-22.5 20.4-23.9a1.51 1.51 0 01.4 3c-12 1.3-17.8 8.1-17.8 21v21.6a1.45 1.45 0 01-1.5 1.4zM148.59 126a1.54 1.54 0 01-1.5-1.5v-21.6c0-12.6-6-19.7-17.8-21a1.51 1.51 0 11.4-3c13.4 1.5 20.5 9.8 20.5 24v21.5a1.72 1.72 0 01-1.6 1.6z",
  transform: "translate(-24.22 -16.3)"
}), /*#__PURE__*/React.createElement("path", {
  className: "ppl_svg__cls-1",
  d: "M104.29 131.75a1.54 1.54 0 01-1.5-1.5v-29.4a1.5 1.5 0 013 0v29.4a1.54 1.54 0 01-1.5 1.5zM138.59 131.75a1.54 1.54 0 01-1.5-1.5v-29.4a1.5 1.5 0 013 0v29.4a1.54 1.54 0 01-1.5 1.5zM121.19 125.45a1.56 1.56 0 01-1.3-.8l-11-19.6a1.71 1.71 0 010-1.4l3.2-6.2-5.9-4.7a1.53 1.53 0 01-.4-1.8l4.8-10.7a1.51 1.51 0 012-.8 1.67 1.67 0 01.9 1.1l9.2 43a1.49 1.49 0 01-1.1 1.8c-.2 0-.3 0-.4.1zm-9.3-21.1l5.7 10.2-3.2-15zM109 91.15l4.3 3.5-1.9-9z",
  transform: "translate(-24.22 -16.3)"
}), /*#__PURE__*/React.createElement("path", {
  className: "ppl_svg__cls-1",
  d: "M121.89 125.45a1.54 1.54 0 01-1.5-1.5v-.3l9.2-43a1.65 1.65 0 011.8-1.2 1.44 1.44 0 011.1.9l4.8 10.7a1.53 1.53 0 01-.4 1.8l-5.9 4.7 3.2 6.2a1.71 1.71 0 010 1.4l-11 19.6a1.43 1.43 0 01-1.3.7zm6.8-25.9l-3.2 15 5.7-10.2zm3-13.9l-2 9 4.3-3.5zM121 67a13.36 13.36 0 01-4-.6 1.52 1.52 0 01.9-2.9 10.42 10.42 0 006.3 0 1.49 1.49 0 011 2.8 12 12 0 01-4.2.7zM123.49 58.45h-2.6a1.54 1.54 0 01-1.5-1.5V51a1.5 1.5 0 013 0v4.5h1.1A1.54 1.54 0 01125 57a1.42 1.42 0 01-1.5 1.5z",
  transform: "translate(-24.22 -16.3)"
}), /*#__PURE__*/React.createElement("path", {
  className: "ppl_svg__cls-1",
  d: "M121.09 88.15c-5 0-9-2.5-9-5.8v-7.5a1.5 1.5 0 013 0v7.5c0 1.1 2.3 2.8 6 2.8s6-1.7 6-2.8v-7.5a1.5 1.5 0 013 0v7.5c0 3.3-4 5.8-9 5.8z",
  transform: "translate(-24.22 -16.3)"
}), /*#__PURE__*/React.createElement("path", {
  className: "ppl_svg__cls-1",
  d: "M120.89 76.65a19.85 19.85 0 01-19.8-19.8V44a17.11 17.11 0 0117.2-17.1h5.2a17.24 17.24 0 0117.2 17.1v12.9a19.78 19.78 0 01-19.8 19.75zm-2.6-46.9A14.25 14.25 0 00104.09 44v13a16.8 16.8 0 0033.6 0V44a14.11 14.11 0 00-14.2-14.1z",
  transform: "translate(-24.22 -16.3)"
}), /*#__PURE__*/React.createElement("path", {
  className: "ppl_svg__cls-1",
  d: "M101.29 58.25a4.4 4.4 0 010-8.8 1.5 1.5 0 010 3 1.4 1.4 0 000 2.8 1.5 1.5 0 110 3zM140.59 58.25a1.5 1.5 0 010-3 1.4 1.4 0 100-2.8 1.5 1.5 0 010-3 4.4 4.4 0 110 8.8zM104.69 45.45a1.51 1.51 0 01-.4-3c7.9-2.1 20.4-7.1 20.3-11.9a1.54 1.54 0 011.5-1.5 1.54 1.54 0 011.5 1.5c0 3.8-3.8 7.5-11.6 11a102.38 102.38 0 01-11 3.9z",
  transform: "translate(-24.22 -16.3)"
}), /*#__PURE__*/React.createElement("path", {
  className: "ppl_svg__cls-1",
  d: "M123.19 45h-.3a39.19 39.19 0 01-10.7-1.7 1.48 1.48 0 01-.9-1.9 1.51 1.51 0 011.8-.9c.2.1 18 5.7 21.6-4.9a1.49 1.49 0 012.8 1c-1.8 5.45-6.8 8.4-14.3 8.4z",
  transform: "translate(-24.22 -16.3)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "ppl_svg__cls-1",
  cx: 89.57,
  cy: 34.75,
  r: 1.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "ppl_svg__cls-1",
  cx: 104.17,
  cy: 34.75,
  r: 1.8
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "ppl_svg___5",
  "data-name": 5
}, /*#__PURE__*/React.createElement("path", {
  className: "ppl_svg__cls-1",
  d: "M53.52 67.4a13.36 13.36 0 01-4-.6 1.52 1.52 0 01.9-2.9 9.71 9.71 0 006.3 0 1.49 1.49 0 011 2.8 11.58 11.58 0 01-4.2.7zM56.12 58.9h-2.6A1.54 1.54 0 0152 57.4v-6a1.5 1.5 0 013 0V56h1.1a1.54 1.54 0 011.5 1.5 1.39 1.39 0 01-1.5 1.4zM25.72 126.2a1.54 1.54 0 01-1.5-1.5v-21.5c0-14.6 7.1-22.6 21.1-23.8a1.5 1.5 0 11.2 3c-12.4 1.1-18.4 7.9-18.4 20.8v21.5a1.34 1.34 0 01-1.4 1.5zM81 126.2a1.54 1.54 0 01-1.5-1.5v-21.5c0-12.9-6-19.7-18.5-20.9a1.5 1.5 0 01.2-3c13.9 1.2 21.2 9.5 21.2 23.8v21.5a1.42 1.42 0 01-1.4 1.6z",
  transform: "translate(-24.22 -16.3)"
}), /*#__PURE__*/React.createElement("path", {
  className: "ppl_svg__cls-1",
  d: "M36.82 132a1.54 1.54 0 01-1.5-1.5v-29.3a1.5 1.5 0 013 0v29.4a1.52 1.52 0 01-1.5 1.4zM71 132a1.54 1.54 0 01-1.5-1.5v-29.3a1.5 1.5 0 013 0v29.4A1.45 1.45 0 0171 132zM53.62 87.8c-5 0-9-2.5-9-5.7v-7.5a1.5 1.5 0 013 0v7.5c0 1.1 2.3 2.7 6 2.7s6-1.6 6-2.7v-7.5a1.5 1.5 0 013 0v7.5c0 3.2-3.9 5.7-9 5.7z",
  transform: "translate(-24.22 -16.3)"
}), /*#__PURE__*/React.createElement("path", {
  className: "ppl_svg__cls-1",
  d: "M53.52 77.2a19.85 19.85 0 01-19.8-19.8V46.5a1.5 1.5 0 013 0v10.9a16.8 16.8 0 1033.6 0V46.5a1.5 1.5 0 013 0v10.9a20 20 0 01-19.8 19.8zM53.62 125.8a1.56 1.56 0 01-1.3-.8l-11-19.6a1.71 1.71 0 010-1.4l3.2-6.2-5.9-4.7a1.53 1.53 0 01-.4-1.8l4.7-10.7a1.51 1.51 0 012-.8 1.67 1.67 0 01.9 1.1l9.2 43a1.49 1.49 0 01-1.1 1.8.37.37 0 01-.3.1zm-9.3-21.1L50 114.9l-3.2-15zm-2.8-13.2l4.3 3.5-1.9-8.9z",
  transform: "translate(-24.22 -16.3)"
}), /*#__PURE__*/React.createElement("path", {
  className: "ppl_svg__cls-1",
  d: "M54.42 125.8a1.54 1.54 0 01-1.5-1.5v-.3l9.2-43a1.65 1.65 0 011.8-1.2 1.44 1.44 0 011.1.9l4.8 10.7a1.53 1.53 0 01-.4 1.8l-5.9 4.7 3.2 6.2a1.71 1.71 0 010 1.4l-11 19.6a1.71 1.71 0 01-1.3.7zm6.8-25.9l-3.2 15 5.7-10.2zm3-13.8l-2 8.9 4.3-3.5zM62.42 28.3a1.54 1.54 0 01-1.5-1.5 7.5 7.5 0 10-15 0 1.5 1.5 0 01-3 0 10.5 10.5 0 1121 0 1.54 1.54 0 01-1.5 1.5z",
  transform: "translate(-24.22 -16.3)"
}), /*#__PURE__*/React.createElement("path", {
  className: "ppl_svg__cls-1",
  d: "M37 47.1a4.3 4.3 0 01-2.7-.8c-1.2-.9-1.8-2.5-1.8-4.9 0-9.8 9.4-17.7 20.9-17.7s20.9 7.9 20.9 17.7c0 2.4-.6 4-1.8 4.9-2 1.5-5 .6-8.6-.5a28 28 0 00-20.9 0 21.53 21.53 0 01-6 1.3zm16.4-6.3A40.41 40.41 0 0164.72 43c2.5.8 5.2 1.6 6 1 .4-.3.6-1.2.6-2.5 0-8.1-8-14.7-17.9-14.7s-17.9 6.6-17.9 14.7c0 1.3.2 2.2.6 2.5.8.6 3.5-.2 6-1a39.06 39.06 0 0111.3-2.2z",
  transform: "translate(-24.22 -16.3)"
}), /*#__PURE__*/React.createElement("path", {
  className: "ppl_svg__cls-1",
  d: "M46.62 43.4a1.54 1.54 0 01-1.5-1.5v-1a29.55 29.55 0 011.1-7.9l.1-.4a1.49 1.49 0 112.9.7v.1l-.1.4a24.57 24.57 0 00-1 7.2v1a1.52 1.52 0 01-1.5 1.4zM59.92 43.4a1.54 1.54 0 01-1.5-1.5v-1a25.53 25.53 0 00-1-7.2l-.1-.4a1.52 1.52 0 112.9-.9v.1l.1.4a30.72 30.72 0 011.1 7.9v1a1.56 1.56 0 01-1.5 1.6zM33.82 58.6a4.4 4.4 0 110-8.8 1.5 1.5 0 110 3 1.4 1.4 0 100 2.8 1.5 1.5 0 010 3zM73.12 58.6a1.5 1.5 0 010-3 1.4 1.4 0 100-2.8 1.5 1.5 0 010-3 4.44 4.44 0 014.4 4.4 4.51 4.51 0 01-4.4 4.4z",
  transform: "translate(-24.22 -16.3)"
}), /*#__PURE__*/React.createElement("circle", {
  className: "ppl_svg__cls-1",
  cx: 22.1,
  cy: 35.1,
  r: 1.8
}), /*#__PURE__*/React.createElement("circle", {
  className: "ppl_svg__cls-1",
  cx: 36.7,
  cy: 35.1,
  r: 1.8
}));

function SvgPpl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ppl_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 125.97 115.7"
  }, props), _ref, _ref2, _ref3);
}

export default SvgPpl;